module.exports = __webpack_public_path__ + "img/wrinkle_l32wsk_c_scale,w_1400.0944f22a.jpg";